import { c as _c } from "react/compiler-runtime";
import { useState, cloneElement, useCallback } from 'react';
import { Menu as MuiMenu } from '@mui/material';
import MenuItem from '../MenuItem';
export default function Menu(t0) {
  const $ = _c(17);
  const {
    anchorElement: t1,
    children: t2,
    isOpen: t3,
    onClose: t4,
    onOpen: t5
  } = t0;
  const anchorElement = t1 === undefined ? null : t1;
  const children = t2 === undefined ? null : t2;
  const isOpen = t3 === undefined ? false : t3;
  const onClose = t4 === undefined ? _temp : t4;
  const onOpen = t5 === undefined ? _temp2 : t5;
  const [anchorEl, setAnchorEl] = useState(null);
  let t6;
  if ($[0] !== isOpen || $[1] !== onClose || $[2] !== onOpen) {
    t6 = e => {
      if (isOpen) {
        onClose();
        setAnchorEl(null);
      } else {
        onOpen();
        setAnchorEl(e.currentTarget);
      }
    };
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = onOpen;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const clickAnchorElementHandler = t6;
  let t7;
  if ($[4] !== anchorElement || $[5] !== clickAnchorElementHandler) {
    t7 = anchorElement && cloneElement(anchorElement, {
      onClick: clickAnchorElementHandler
    });
    $[4] = anchorElement;
    $[5] = clickAnchorElementHandler;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      vertical: "bottom",
      horizontal: "left"
    };
    t9 = {
      component: "nav"
    };
    $[7] = t8;
    $[8] = t9;
  } else {
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] !== anchorEl || $[10] !== children || $[11] !== isOpen || $[12] !== onClose) {
    t10 = <MuiMenu anchorEl={anchorEl} anchorOrigin={t8} MenuListProps={t9} open={isOpen} onClose={onClose}>{children}</MuiMenu>;
    $[9] = anchorEl;
    $[10] = children;
    $[11] = isOpen;
    $[12] = onClose;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t7) {
    t11 = <>{t7}{t10}</>;
    $[14] = t10;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}
function _temp2() {}
function _temp() {}
Menu.Item = MenuItem;